var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "action-btn",
      class: { disabled: _vm.disabled },
      on: { click: _vm.handleClick }
    },
    [
      _c("div", { staticClass: "button-content" }, [
        _vm.iconSrc
          ? _c(
              "div",
              {
                staticClass: "icon-container",
                style: { backgroundColor: _vm.getIconColor(_vm.iconSrc) }
              },
              [
                _c("InlineSvg", {
                  staticClass: "action-inline-svg",
                  attrs: { src: _vm.iconSrc }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "button-text" }, [_vm._v(_vm._s(_vm.text))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }